"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndeavourCredits = exports.PXLWidgetsCredits = void 0;
var config_1 = require("./config");
var logo_1 = require("./logo");
function PXLWidgetsCredits(settings) {
    EndeavourCredits(settings);
}
exports.PXLWidgetsCredits = PXLWidgetsCredits;
function EndeavourCredits(settings) {
    var segments = [
        [
            heading(settings.projectName || location.host),
        ],
        ['%c ', logo()],
    ];
    if (settings.collaborators && settings.collaborators.length) {
        segments.push([
            [
                'Collaborators',
                separator(),
                '',
                formatCollaborators(settings.collaborators),
                '',
                separator(),
                '',
            ].join('\n')
        ]);
    }
    segments.forEach(function (args) {
        console.log.apply(console, args);
    });
}
exports.EndeavourCredits = EndeavourCredits;
// ------------------------------------------------------------------------------
//      Loggers
// ------------------------------------------------------------------------------
function heading(projectName) {
    return "".concat(projectName, " by ").concat(config_1.company, " | ").concat(config_1.website);
}
function separator(width) {
    if (width === void 0) { width = 60; }
    return repeat(width, "-");
}
function formatCollaborators(list) {
    var nameWidth = Math.max.apply(Math, list.map(function (col) { return col.name.length; }));
    var descWidth = Math.max.apply(Math, list.map(function (col) { return col.description.length; }));
    return list
        .map(function (_a) {
        var name = _a.name, description = _a.description, url = _a.url;
        var nameSegment = name + repeat(nameWidth - name.length, ' ');
        var descSegment = description + repeat(descWidth - description.length, ' ');
        return url
            ? "".concat(nameSegment, " | ").concat(descSegment, " | ").concat(url)
            : "".concat(nameSegment, " | ").concat(descSegment);
    })
        .join('\n');
}
function logo() {
    return [
        'font-size: 1px;',
        'padding: 160px;',
        "background: url(data:image/svg+xml;base64,".concat(btoa(logo_1.logoSVG), ") no-repeat;"),
        'background-size: contain;'
    ].join(' ');
}
// ------------------------------------------------------------------------------
//      Utils
// ------------------------------------------------------------------------------
var repeat = function (count, element) {
    var sequence = '';
    while (count--) {
        sequence += element;
    }
    return sequence;
};
//# sourceMappingURL=index.js.map